/**
 * @generated SignedSource<<6f03238ad884981800afd008588db061>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileStatus = "ERROR" | "PENDING" | "PROCESSING" | "READY" | "WAIT_FOR_PROCESSING";
import { FragmentRefs } from "relay-runtime";
export type WidgetFileDynamic_widgetFile$data = {
  readonly files: ReadonlyArray<{
    readonly file: {
      readonly id: string;
      readonly name: string | null;
      readonly status: FileStatus;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetFilePageProcessing_file">;
    };
    readonly pages: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetFilePage_page">;
    }>;
  }>;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetFileStatic_widgetFile">;
  readonly " $fragmentType": "WidgetFileDynamic_widgetFile";
};
export type WidgetFileDynamic_widgetFile$key = {
  readonly " $data"?: WidgetFileDynamic_widgetFile$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetFileDynamic_widgetFile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetFileDynamic_widgetFile",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetFileStatic_widgetFile"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetFileEdge",
      "kind": "LinkedField",
      "name": "files",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FilePage",
          "kind": "LinkedField",
          "name": "pages",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetFilePage_page"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "File",
          "kind": "LinkedField",
          "name": "file",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetFilePageProcessing_file"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetFile",
  "abstractKey": null
};
})();

(node as any).hash = "25f795d19cc8080e096c3691eef21df1";

export default node;
